import type { NegotiationVariableContext } from '../core/context'
import { defineVariable, type NegotiationVariable } from '../core/define'
import { defineObjectGroup } from '../core/define-object-group'

/**
 * Representante legal de la SOCIEDAD VENDEDORA (uno por documento — legítimamente escalar) +
 * frases de cierre de la parte compradora.
 *
 * El metadato está en `@idc-forms/schemas/variables/document/representante.variables`. La
 * RESOLUCIÓN real todavía la inyecta la operación del template (`generate-data-promise.ts`) como
 * override sobre el mapa plano; el resolver central devuelve '' hasta migrar la lógica de
 * comparecencia (fase posterior, con verificación viva). Ausente y '' renderizan idéntico
 * (`{{token}}`), por eso no hay regresión.
 */
const rep =
  (key: string) =>
  (c: NegotiationVariableContext): string =>
    c.representante?.[key] ?? ''

export const REPRESENTANTE_VARIABLES: NegotiationVariable[] = defineObjectGroup('representante', {
  nombre: rep('nombre'),
  edad: rep('edad'),
  estado_civil: rep('estado_civil'),
  nacionalidad: rep('nacionalidad'),
  profesion: rep('profesion'),
  departamento: rep('departamento'),
  dpi_letras: rep('dpi_letras'),
  dpi_numeros: rep('dpi_numeros'),
  cargo: rep('cargo'),
  entidad: rep('entidad'),
  nombramiento_fecha: rep('nombramiento_fecha'),
  notario_tratamiento: rep('notario_tratamiento'),
  notario_nombre: rep('notario_nombre'),
  registro_numero: rep('registro_numero'),
  registro_folio: rep('registro_folio'),
  registro_libro: rep('registro_libro')
})

// Cierre / parte compradora. Tokens con guion_bajo (no `prefijo.campo`), por eso son
// defineVariable suelto y no defineObjectGroup; el `group` los anida en el picker.
export const CIERRE_VARIABLES: NegotiationVariable[] = [
  defineVariable('parte_compradora_nombre', (c) => c.parteCompradora?.nombre ?? ''),
  defineVariable('parte_compradora_frase', (c) => c.parteCompradora?.frase ?? '')
]
